import { render, staticRenderFns } from "./TechDrilling.vue?vue&type=template&id=ef53cf80&"
import script from "./TechDrilling.vue?vue&type=script&lang=js&"
export * from "./TechDrilling.vue?vue&type=script&lang=js&"
import style0 from "./TechDrilling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports